<template>
  <div id="sidebar-wrapper">
    <transition name="slide">
      <div id="sidebar" v-show="opened">
        <div class="menu-icon" @click="$parent.$data.sidebarIsOpen = !$parent.$data.sidebarIsOpen" v-show="$parent.$data.sidebarIsOpen">
          <v-icon name="times" scale="2"></v-icon>
        </div>
        <ul>
          <li v-for="(link, index) in links" :key="link.name">
            <router-link
              exact
              :to="{ name: link.route }"
              class="hvr-underline-from-left"
              @click.native="$emit('closeSideBar', false); toggleShowNested(index)"
            >{{ link.name }}</router-link>
            <ul v-if="link.nested && showNested === index">
              <li v-for="nestedLink in link.nested" :key="nestedLink.name">
                <router-link
                  :to="{ name: nestedLink.route }"
                  class="hvr-underline-from-left"
                  @click.native="$emit('closeSideBar', false)"
                >{{ nestedLink.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </transition>
    <div class="overlay" v-show="opened" @click="$emit('closeSideBar', false)"></div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    links: {
      type: Array,
      required: true
    },
    opened: {
      tye: Boolean,
      default: true
    }
  },
  data () {
    return {
      showNested: null
    }
  },
  methods: {
    toggleShowNested (index) {
      this.showNested = index
    }
  }
}
</script>

<style lang="scss" scoped>
#sidebar {
  background-color: #fff;
  border-right: 1px solid #eee;
  padding: 0 10px;
  position: absolute;
  height: 100%;
  width: 180px;
  z-index: 10001;
  .menu-icon {
    right: 10px;
    left: auto;
  }
  & > ul {
    margin: 50px 0 0 0;
  }
  ul {
    padding: 0;
    list-style: none;
    li {
      padding: 10px 20px;
    }
  }
}
.overlay {
  position: absolute;
  background-color: black;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  z-index: 10000;
}
.slide-enter-active {
  transition: all 0.7s ease;
}
.slide-leave-active {
  transition: all 0.7s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-355px);
}

@media (min-width: 1200px) {
  #sidebar {
    position: relative;
    padding: 30px 10px 0 10px;
    & > ul {
      margin: 0;
    }
    .menu-icon {
      display: none;
    }
  }
  .overlay {
    display: none;
  }
}
</style>
